import type { OrderingLedger } from '../machines/ordering-machine.types';

/**
 * Given a ledger, return the maximum tip amount that can be applied to the order.
 */
export const getMaxTipAmount = (ledger?: OrderingLedger) => {
  const orderSubtotal = ledger?.subtotal ?? 0;
  const orderDiscountsTotal = ledger?.discountsTotal ?? 0;

  return Math.floor(orderSubtotal - orderDiscountsTotal);
};
